
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zmianaoplat",
      function () {
        return require("private-next-pages/zmianaoplat.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zmianaoplat"])
      });
    }
  